var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }